import { Stepper } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Stepper)`
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
`;
